import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { AxlPanel, AxlDateInput } from 'axl-reactjs-ui';
import { Radio, FormControlLabel, Checkbox } from '@material-ui/core';

// Utils
import { SHIPMENT_SERVICE_LEVEL } from '../../../../constants/status';

// styles
import styles, * as E from '../../styles';

export default class SingleOrderStepFour extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customWindowError : false,
      deliveryWindowShiftStatus: 'shift_1'
    }
  }

  timeRender = (time) => {
    if(!time || time === '') return '00:00 AM/PM';
    return <E.Text_3>{moment(time).format('hh:mm A')}</E.Text_3>;
  };

  render() {
    const {
      getFormError, getFormWarning, getFormValue, handleInputForm, handleDateTimeInput, handleTimeWindowChange, handleShiftChange,
      weekDeliveryWindows, disableCustomWindow, shipment, deliveryWindows, deliveryWindowShifts, selectedShift, selectedGroup,
    } = this.props;
    const { ASAP, SAME_DAY, NEXT_DAY } = SHIPMENT_SERVICE_LEVEL;
    const selectedWindow = getFormValue("delivery_window");
    const today = moment().format('MM/DD/YYYY');
    const currentTimeTS = parseInt(moment().format('x'));
    let pickupDisabled = false;
    let deliveryDisabled = false;
    const newDateISO = new Date().toISOString();
    const pickupDateDefaultValue = getFormValue("pickup_date_ts");
    const deliveryDateDefaultValue = getFormValue("dropoff_date_ts");
    let pickupDateMinValue = newDateISO;
    let pickupDateMaxValue = null;
    let deliveryDateMinValue = newDateISO;
    let deliveryDateMaxValue = null;
    let currentWeekday = '';

    if(getFormValue('service_level') === ASAP) {
      pickupDisabled = true;
      deliveryDisabled = true;
    } else if(getFormValue('service_level') === SAME_DAY) {
      // some logic
    } else if(getFormValue('service_level') === NEXT_DAY) {
      // some logic
    }

    if(getFormValue("pickup_date_ts")) {
      deliveryDateMinValue = new Date(new Date(getFormValue("pickup_date_ts")).valueOf() + 6*3600*1000).toISOString();
    }

    if(deliveryDateDefaultValue) {
      pickupDateMaxValue = new Date(new Date(deliveryDateDefaultValue).valueOf() + 6*3600*1000).toISOString();
      currentWeekday = moment(deliveryDateDefaultValue).format('ddd').toLowerCase();
    }

    const deliveryWindowsList = weekDeliveryWindows[currentWeekday] || deliveryWindows;
    const pickupTimeOption = {
      enableTime: true,
      noCalendar: true
    };
    const pickupDateOption = {
      dateFormat: 'MM/DD/YYYY',
      placeHolder: moment().format('MM/DD/YYYY'),
      clickOpens: true,
      altInputClass: 'form-control',
      defaultValue: pickupDateDefaultValue,
      minDate: pickupDateMinValue,
      maxDate: pickupDateMaxValue,
    };
    const dropoffDateOption = {
      dateFormat: 'MM/DD/YYYY',
      placeHolder: moment().format('MM/DD/YYYY'),
      clickOpens: true,
      altInputClass: 'form-control',
      defaultValue: deliveryDateDefaultValue,
      minDate: deliveryDateMinValue,
      maxDate: deliveryDateMaxValue
    };
    const timeWindowsOption = {
      enableTime: true,
      noCalendar: true
    };

    return (<E.StepContainer>
      <E.Panel>
        <E.PanelTitle>{`Shipping Information`}</E.PanelTitle>
        <E.PanelContent>
          <AxlPanel>
            <E.Label isError={!!getFormError("service_level")}>{`Delivery Service`}<E.Text_4 isError={!!getFormError("service_level")}>{` - required`}</E.Text_4></E.Label>
            <AxlPanel.Row style={styles.row}>
              <AxlPanel.Col style={styles.col_1}>
                <E.Label style={{marginBottom: 0}}>{`ASAP?`}</E.Label>
                <Radio
                  error={getFormError("service_level")}
                  checked={getFormValue('service_level') === ASAP}
                  name={`service_level`}
                  value={ASAP}
                  onChange={handleInputForm}
                  color="primary"
                />
              </AxlPanel.Col>
              <AxlPanel.Col style={styles.col_1}>
                <E.Label style={{marginBottom: 0}}>{`Same-day?`}</E.Label>
                <Radio
                  error={getFormError("service_level")}
                  checked={getFormValue('service_level') === SAME_DAY}
                  name={`service_level`}
                  value={SAME_DAY}
                  onChange={handleInputForm}
                  color="primary"
                />
              </AxlPanel.Col>
              <AxlPanel.Col style={styles.col_1}>
                <E.Label style={{marginBottom: 0}}>{`Next-day?`}</E.Label>
                <Radio
                  error={getFormError("service_level")}
                  checked={getFormValue('service_level') === NEXT_DAY}
                  name={`service_level`}
                  value={NEXT_DAY}
                  onChange={handleInputForm}
                  color="primary"
                />
              </AxlPanel.Col>
            </AxlPanel.Row>
            <E.DescriptionBox>
              <E.Text_1><E.B>{`ASAP: `}</E.B>{`Pick up and deliver today ${today} ASAP`}</E.Text_1>
              <E.Text_1><E.B>{`Same-day: `}</E.B>{`Pick up and delivery both on specified date`}</E.Text_1>
              <E.Text_1><E.B>{`Next-day: `}</E.B>{`Pick up any day before delivery date`}</E.Text_1>
            </E.DescriptionBox>
            <AxlPanel.Row style={styles.row}>
              <AxlPanel.Col style={styles.col}>
                <E.Label>{`Pick-Up Date`}</E.Label>
                <AxlDateInput
                  name="pickup_date_ts"
                  onChange={handleDateTimeInput("pickup_date_ts")}
                  error={getFormError("pickup_date_ts")}
                  warning={!getFormError("pickup_date_ts") && getFormWarning("pickup_date_ts")}
                  value={getFormValue("pickup_date_ts")}
                  displayToday={false}
                  options={pickupDateOption}
                  theme={`main`} showError={false}
                  disabled={pickupDisabled}
                />
              </AxlPanel.Col>
              <AxlPanel.Col style={styles.col}>
                <E.Label isError={!!getFormError("dropoff_date_ts")}>{`Delivery Date`}<E.Text_4 isError={!!getFormError("dropoff_date_ts")}>{` - required`}</E.Text_4></E.Label>
                <AxlDateInput
                  name="dropoff_date_ts"
                  onChange={handleDateTimeInput("dropoff_date_ts")}
                  error={getFormError("dropoff_date_ts")}
                  warning={!getFormError("dropoff_date_ts") && getFormWarning("dropoff_date_ts")}
                  value={getFormValue("dropoff_date_ts")}
                  displayToday={false}
                  options={dropoffDateOption}
                  theme={`main`}
                  showError={false}
                  disabled={deliveryDisabled}
                />
              </AxlPanel.Col>
            </AxlPanel.Row>
            <AxlPanel.Row style={styles.row}>
              <AxlPanel.Col style={styles.col}>
                <E.Label>{`Earliest Pick-Up Time`}</E.Label>
                <E.DateTime>
                  <AxlDateInput
                    name="pickup_earliest_time"
                    onChange={handleDateTimeInput("pickup_earliest_time")}
                    error={getFormError("pickup_earliest_time")}
                    warning={!getFormError("pickup_earliest_time") && getFormWarning("pickup_earliest_time")}
                    value={getFormValue("pickup_earliest_time")}
                    displayToday={false}
                    theme={`secondary`} clear
                    options={{
                      ...pickupTimeOption,
                      defaultValue: shipment.pickup_earliest_time
                    }}
                  >{this.timeRender(getFormValue("pickup_earliest_time"))}</AxlDateInput>
                </E.DateTime>
              </AxlPanel.Col>
              <AxlPanel.Col style={styles.col}>
                <E.Label>{`Latest Pick-Up Time`}</E.Label>
                <AxlDateInput
                  name="pickup_latest_time"
                  onChange={handleDateTimeInput("pickup_latest_time")}
                  error={getFormError("pickup_latest_time")}
                  warning={!getFormError("pickup_latest_time") && getFormWarning("pickup_latest_time")}
                  value={getFormValue("pickup_latest_time")}
                  displayToday={false}
                  theme={`secondary`} clear
                  options={{
                    ...pickupTimeOption,
                    defaultValue: shipment.pickup_latest_time
                  }}
                >{this.timeRender(getFormValue("pickup_latest_time"))}</AxlDateInput>
              </AxlPanel.Col>
            </AxlPanel.Row>
            <AxlPanel.Row style={styles.row}>
              <AxlPanel.Col style={styles.col}>
                <E.Label isError={!!getFormError("delivery_window")}>
                  {`Delivery window`}
                  <E.Text_4 isError={!!getFormError("delivery_window")}>{` - required`}</E.Text_4>
                </E.Label>
                {deliveryWindowShifts.length === 0 &&
                  <E.DeliveryWindowContainer>
                    {deliveryWindowsList && deliveryWindowsList.map((delivery, index) => {
                      const deliveryDate = moment(deliveryDateDefaultValue).format('MM/DD/YYYY');
                      const currentDETS = parseInt(moment(`${deliveryDate} ${delivery[0]}`, 'MM/DD/YYYY hh:mmA').format('x'));
                      const disabled = currentDETS < currentTimeTS - 60 * 60 * 1000;

                      return (
                        <E.DeliveryWindow key={index} style={{ opacity: disabled ? 0.5 : 1 }}>
                          <FormControlLabel
                            style={{marginRight: 10}}
                            control={
                              <Radio
                                name={`delivery_window`}
                                checked={_.isEqual(selectedWindow, index + 1)}
                                value={index}
                                error={getFormError('delivery_window')}
                                onChange={handleTimeWindowChange(index, delivery)}
                                color="primary"
                                disabled={disabled}
                              />
                            }
                            label={delivery.join(' - ')}
                          />
                        </E.DeliveryWindow>
                      )
                    })}
                    <E.DeliveryWindow>
                      {!disableCustomWindow && (
                        <FormControlLabel
                          style={{marginRight: 10}}
                          control={
                            <Radio
                              name={`delivery_window`}
                              checked={_.isEqual(selectedWindow, "new")}
                              value={"new"}
                              error={getFormError('delivery_window')}
                              onChange={handleTimeWindowChange("new", null)}
                              color="primary"
                            />
                          }
                          label="Create New Window"
                        />
                      )}
                      {getFormValue('delivery_window') === 'new' && (
                        <AxlPanel.Row style={styles.row_3}>
                          <AxlPanel.Col style={styles.col}>
                            <AxlDateInput
                              name="dropoff_earliest_time"
                              onChange={handleDateTimeInput('dropoff_earliest_time')}
                              error={getFormError('dropoff_earliest_time')}
                              warning={!getFormError('dropoff_earliest_time') && getFormWarning("dropoff_earliest_time")}
                              displayToday={false}
                              options={{
                                ...timeWindowsOption,
                                defaultValue: getFormValue('dropoff_earliest_time'),
                              }}
                              theme={`main`}
                            >{this.timeRender(getFormValue("dropoff_earliest_time"))}</AxlDateInput>
                          </AxlPanel.Col>
                          <AxlPanel.Col style={styles.col}>
                            <AxlDateInput
                              name="dropoff_latest_time"
                              onChange={handleDateTimeInput('dropoff_latest_time')}
                              error={getFormError('dropoff_latest_time')}
                              warning={!getFormError('dropoff_latest_time') && getFormWarning("dropoff_latest_time")}
                              displayToday={false}
                              options={{
                                ...timeWindowsOption,
                                defaultValue: getFormValue('dropoff_latest_time'),
                              }}
                              theme={`main`}
                            >{this.timeRender(getFormValue("dropoff_latest_time"))}</AxlDateInput>
                          </AxlPanel.Col>
                        </AxlPanel.Row>
                      )}
                      {this.state.customWindowError && (
                        <div style={{ textAlign: 'center', marginTop: 10 }}>
                          <E.I style={{ color: '#ff0000' }}>Delivery window must from lower to greater</E.I>
                        </div>
                      )}
                    </E.DeliveryWindow>
                  </E.DeliveryWindowContainer>
                }
                {deliveryWindowShifts.length > 0 &&
                  <div>
                    <E.DeliveryWindowShift>
                      {deliveryWindowShifts.map((shift, index) =>
                        <E.Col key={index}>
                          <FormControlLabel
                            control={
                              <Radio
                                checked={_.isEqual(parseInt(selectedShift), index)}
                                name={`delivery_window_shift`}
                                value={index}
                                onChange={handleShiftChange}
                                color="primary"
                                disabled={false}
                              />
                            }
                            label={<p><strong>{shift.label}</strong> <span>({shift.descr})</span></p>}
                          />
                        </E.Col>)}
                    </E.DeliveryWindowShift>
                    <E.DeliveryWindowShiftContainer>
                      <E.Row>
                        {deliveryWindowShifts[selectedShift].windows_group.map((windowsGroup, idx) => (
                          <E.Col key={idx}>
                            <E.Label_2>{windowsGroup.label}</E.Label_2>
                            {windowsGroup.windows.map((delivery, index) =>
                              <E.DeliveryWindowMain key={index}>
                                <FormControlLabel
                                  control={
                                    <Radio
                                      checked={_.isEqual(selectedGroup, idx) && _.isEqual(selectedWindow, index + 1)}
                                      name={`delivery_window`}
                                      value={index}
                                      error={getFormError(`delivery_window`)}
                                      onChange={handleTimeWindowChange(index, delivery, idx)}
                                      color="primary"
                                      disabled={false}
                                    />
                                  }
                                  label={delivery.join(' - ')}
                                />
                              </E.DeliveryWindowMain>)}
                          </E.Col>
                        ))}
                      </E.Row>
                    </E.DeliveryWindowShiftContainer>
                  </div>
                }
              </AxlPanel.Col>
            </AxlPanel.Row>
            <AxlPanel.Row style={styles.row}>
              <AxlPanel.Col style={styles.col}>
                <E.CheckboxGroup>
                  <E.CheckboxItem>
                    <E.Label>{`Required Service`}</E.Label>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleInputForm}
                          name="delivery_proof_photo_required"
                          value={getFormValue("delivery_proof_photo_required")}
                          checked={getFormValue("delivery_proof_photo_required")}
                          color="primary"
                        />
                      }
                      label="Photo POD"
                    />
                  </E.CheckboxItem>
                  <E.CheckboxItem>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleInputForm}
                          name="signature_required"
                          value={getFormValue("signature_required")}
                          checked={getFormValue("signature_required")}
                          color="primary"
                        />
                      }
                      label="Signature"
                    />
                  </E.CheckboxItem>
                  <E.CheckboxItem>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleInputForm}
                          name="id_required"
                          value={getFormValue("id_required")}
                          checked={getFormValue("id_required")}
                          color="primary"
                        />
                      }
                      label="ID Check"
                    />
                  </E.CheckboxItem>
                  <E.CheckboxItem>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleInputForm}
                          name="sms_enabled"
                          value={getFormValue("sms_enabled")}
                          checked={getFormValue("sms_enabled")}
                          color="primary"
                        />
                      }
                      label="SMS Enable"
                    />
                  </E.CheckboxItem>
                </E.CheckboxGroup>
              </AxlPanel.Col>
            </AxlPanel.Row>
          </AxlPanel>
        </E.PanelContent>
      </E.Panel>
    </E.StepContainer>);
  }
}
